import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'feature-ion-withdraw-wire-transfer',
  templateUrl: './wire-transfer.component.html',
  styleUrls: ['./wire-transfer.component.scss'],
  standalone: true,
})
export class WireTransferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    null;
  }

}
